export default __webpack_public_path__ + "static/media/logo-big.c4f6aa37.jpg";